import { IGroup } from '../services/group/group.model'
import { formatGroupLabel, sortGroupsByGhgCategory } from '../constants/ghg-category'

// The groups a person can pick on the emissions overview: every Scope 1 and 2 group, and the Scope 3
// groups the organisation has switched on, plus `keepGroupId` when editing something already linked
// to a group that has since been switched off. In GHG order (scope, then Scope 3 category number),
// labelled with the app's numbered group label ("Scope 3.6: Business Travel"). Used by the Add
// Assumption dialog and the overview's note Group list, so both offer the same groups the same way.
export function getSelectableGroups<T extends Pick<IGroup, 'id' | 'scope' | 'title' | 'isTagged' | 'scope3CategoryNumber'>>(groups: T[], keepGroupId?: string | null): T[] {
  return sortGroupsByGhgCategory(groups.filter(group => group.scope !== '3' || group.isTagged || group.id === keepGroupId))
}

export const groupOptionLabel = (group: Pick<IGroup, 'id' | 'scope' | 'title' | 'scope3CategoryNumber'>): string => formatGroupLabel(group)
